import cashDeskInstance from '../instance'

const createClientMonitorQrCodeLink = (desktopDeviceId, data) => {
  return cashDeskInstance.post(`/passQrCodeLink/${desktopDeviceId}`, data)
}

export default createClientMonitorQrCodeLink
